import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Route is /: the product has no index page. It redirects to /studio in
 * beforeLoad (no component), so anonymous users chain / -> /studio -> the _app
 * guard -> /login?return_to=/studio. A __root redirect was rejected: it would
 * fire for every path including /studio/embed and /login.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/studio" });
  },
});
